import { List, fromJS } from 'immutable';
import { THEME, themes } from 'reporting-ui-components/constants/themes';
import { getBrandKit } from 'reporting-ui-components/reports/utils/colors/brandKitUtils';
export const getPaletteColorScheme = (colorConfig, brandKitPalettes) => {
  var _reverse, _ref;
  const immutableColorConfig = fromJS(colorConfig);
  const paletteTheme = immutableColorConfig.get('theme');
  const brandKitId = immutableColorConfig.get('brandKitId');
  const {
    scheme: brandKitScheme
  } = getBrandKit(paletteTheme, brandKitPalettes, brandKitId) || {};

  // TODO: fix this typing
  const result = brandKitScheme || (paletteTheme !== THEME.MULTI ? ((_reverse = (_ref = themes.get(paletteTheme, List())).reverse) === null || _reverse === void 0 ? void 0 : _reverse.call(_ref)) ||
  // pattern theme is not a list and cannot be reversed
  themes.get(paletteTheme, List()) : themes.get(THEME.MULTI));
  return result;
};